export default __webpack_public_path__ + "static/media/bird3.a74f9428.svg";